import React from 'react';
import { classNames } from '../../Services/helpers';

import {ReactComponent as LightCalendarCheck} from '../../Icons/Light/calendar-check.svg';
import {ReactComponent as LightGear} from '../../Icons/Light/gear.svg';
import {ReactComponent as LightHouseChimney} from '../../Icons/Light/house-chimney.svg';
import {ReactComponent as LightSquareQuestion} from '../../Icons/Light/square-question.svg';
import {ReactComponent as LightTruck} from '../../Icons/Light/truck.svg';
import {ReactComponent as LightUsers} from '../../Icons/Light/users.svg';

import {ReactComponent as LightAlarmClock} from '../../Icons/Light/alarm-clock.svg';
import {ReactComponent as LightArrowProgress} from '../../Icons/Light/arrow-progress.svg';
import {ReactComponent as LightArrowRightToBracket} from '../../Icons/Light/arrow-right-to-bracket.svg';
import {ReactComponent as LightArrowsUpDown} from '../../Icons/Light/arrows-up-down.svg';
import {ReactComponent as LightArrowUpRightFromSquare} from '../../Icons/Light/arrow-up-right-from-square.svg';
import {ReactComponent as LightBackward} from '../../Icons/Light/backward.svg';
import {ReactComponent as LightBan} from '../../Icons/Light/ban.svg';
import {ReactComponent as LightBars} from '../../Icons/Light/bars.svg';
import {ReactComponent as LightBarsFilter} from '../../Icons/Light/bars-filter.svg';
import {ReactComponent as LightBell} from '../../Icons/Light/bell.svg';
import {ReactComponent as LightBellOn} from '../../Icons/Light/bell-on.svg';
import {ReactComponent as LightBook} from '../../Icons/Light/book.svg';
import {ReactComponent as LightBoxDollar} from '../../Icons/Light/box-dollar.svg';
import {ReactComponent as LightBuilding} from '../../Icons/Light/building.svg';
import {ReactComponent as LightBuildingColumns} from '../../Icons/Light/building-columns.svg';
import {ReactComponent as LightBullseyeArrow} from '../../Icons/Light/bullseye-arrow.svg';
import {ReactComponent as LightBullhorn} from '../../Icons/Light/bullhorn.svg';
import {ReactComponent as LightCalendar} from '../../Icons/Light/calendar.svg';
import {ReactComponent as LightCalendarClock} from '../../Icons/Light/calendar-clock.svg';
import {ReactComponent as LightCalendarDay} from '../../Icons/Light/calendar-day.svg';
import {ReactComponent as LightCalendarPen} from '../../Icons/Light/calendar-pen.svg';
import {ReactComponent as LightCalendarPlus} from '../../Icons/Light/calendar-plus.svg';
import {ReactComponent as LightCalendarWeek} from '../../Icons/Light/calendar-week.svg';
import {ReactComponent as LightCalendarX} from '../../Icons/Light/calendar-xmark.svg';
import {ReactComponent as LightCamera} from '../../Icons/Light/camera.svg';
import {ReactComponent as LightChartSimple} from '../../Icons/Light/chart-simple.svg';
import {ReactComponent as LightCheck} from '../../Icons/Light/check.svg';
import {ReactComponent as LightCheckDouble} from '../../Icons/Light/check-double.svg';
import {ReactComponent as LightCircle} from '../../Icons/Light/circle.svg';
import {ReactComponent as LightCircleCheck} from '../../Icons/Light/circle-check.svg';
import {ReactComponent as LightCircleDot} from '../../Icons/Light/circle-dot.svg';
import {ReactComponent as LightCircleExclamation} from '../../Icons/Light/circle-exclamation.svg';
import {ReactComponent as LightCircleInfo} from '../../Icons/Light/circle-info.svg';
import {ReactComponent as LightCircleX} from '../../Icons/Light/circle-x.svg';
import {ReactComponent as LightClipboardCheck} from '../../Icons/Light/clipboard-check.svg';
import {ReactComponent as LightClock} from '../../Icons/Light/clock.svg';
import {ReactComponent as LightClockRotateLeft} from '../../Icons/Light/clock-rotate-left.svg';
import {ReactComponent as LightCloudArrowDown} from '../../Icons/Light/cloud-arrow-down.svg';
import {ReactComponent as LightCloudArrowUp} from '../../Icons/Light/cloud-arrow-up.svg';
import {ReactComponent as LightComment} from '../../Icons/Light/comment.svg';
import {ReactComponent as LightCopy} from '../../Icons/Light/copy.svg';
import {ReactComponent as LightCreditCardFront} from '../../Icons/Light/credit-card-front.svg';
import {ReactComponent as LightDownChevron} from '../../Icons/Light/chevron-down.svg';
import {ReactComponent as LightDownChevrons} from '../../Icons/Light/chevrons-down.svg';
import {ReactComponent as LightDrawPolygon} from '../../Icons/Light/draw-polygon.svg';
import {ReactComponent as LightEnvelopeOpen} from '../../Icons/Light/envelope-open.svg';
import {ReactComponent as LightExclamation} from '../../Icons/Light/exclamation.svg';
import {ReactComponent as LightEye} from '../../Icons/Light/eye.svg';
import {ReactComponent as LightEyeSlash} from '../../Icons/Light/eye-slash.svg';
import {ReactComponent as LightFileCheck} from '../../Icons/Light/file-check.svg';
import {ReactComponent as LightFileCertificate} from '../../Icons/Light/file-certificate.svg';
import {ReactComponent as LightFileInvoice} from '../../Icons/Light/file-invoice.svg';
import {ReactComponent as LightFileLines} from '../../Icons/Light/file-lines.svg';
import {ReactComponent as LightFilePlusMinus} from '../../Icons/Light/file-plus-minus.svg';
import {ReactComponent as LightFolderImage} from '../../Icons/Light/folder-image.svg';
import {ReactComponent as LightFolderOpen} from '../../Icons/Light/folder-open.svg';
import {ReactComponent as LightForward} from '../../Icons/Light/forward.svg';
import {ReactComponent as LightForwardStep} from '../../Icons/Light/forward-step.svg';
import {ReactComponent as LightHandPointer} from '../../Icons/Light/hand-pointer.svg';
import {ReactComponent as LightGift} from '../../Icons/Light/gift.svg';
import {ReactComponent as LightGiftCard} from '../../Icons/Light/gift-card.svg';
import {ReactComponent as LightGlobePointer} from '../../Icons/Light/globe-pointer.svg';
import {ReactComponent as LightInfo} from '../../Icons/Light/info.svg';
import {ReactComponent as LightLayerGroup} from '../../Icons/Light/layer-group.svg';
import {ReactComponent as LightLeftChevron} from '../../Icons/Light/chevron-left.svg';
import {ReactComponent as LightLink} from '../../Icons/Light/link.svg';
import {ReactComponent as LightListCheck} from '../../Icons/Light/list-check.svg';
import {ReactComponent as LightListUl} from '../../Icons/Light/list-ul.svg';
import {ReactComponent as LightLocationPin} from '../../Icons/Light/location-pin.svg';
import {ReactComponent as LightLocationQuestion} from '../../Icons/Light/location-question.svg';
import {ReactComponent as LightLock} from '../../Icons/Light/lock.svg';
import {ReactComponent as LightMagnifyingGlass} from '../../Icons/Light/magnifying-glass.svg';
import {ReactComponent as LightMagnifyingGlassChart} from '../../Icons/Light/magnifying-glass-chart.svg';
import {ReactComponent as LightMicrophone} from '../../Icons/Light/microphone.svg';
import {ReactComponent as LightMinus} from '../../Icons/Light/minus.svg';
import {ReactComponent as LightMoneyBillTransfer} from '../../Icons/Light/money-bill-transfer.svg';
import {ReactComponent as LightMoneyBillWave} from '../../Icons/Light/money-bill-wave.svg';
import {ReactComponent as LightNote} from '../../Icons/Light/note.svg';
import {ReactComponent as LightPaperclip} from '../../Icons/Light/paperclip.svg';
import {ReactComponent as LightPaperPlane} from '../../Icons/Light/paper-plane.svg';
import {ReactComponent as LightPartyHorn} from '../../Icons/Light/party-horn.svg';
import {ReactComponent as LightPencil} from '../../Icons/Light/pencil.svg';
import {ReactComponent as LightPhone} from '../../Icons/Light/mobile.svg';
import {ReactComponent as LightPiggyBank} from '../../Icons/Light/piggy-bank.svg';
import {ReactComponent as LightPipe} from '../../Icons/Light/pipe.svg';
import {ReactComponent as LightPlay} from '../../Icons/Light/play.svg';
import {ReactComponent as LightPlayPause} from '../../Icons/Light/play-pause.svg';
import {ReactComponent as LightPlus} from '../../Icons/Light/plus.svg';
import {ReactComponent as LightPlusMinus} from '../../Icons/Light/plus-minus.svg';
import {ReactComponent as LightQuestion} from '../../Icons/Light/question.svg';
import {ReactComponent as LightReceipt} from '../../Icons/Light/receipt.svg';
import {ReactComponent as LightRightChevron} from '../../Icons/Light/chevron-right.svg';
import {ReactComponent as LightRocketLaunch} from '../../Icons/Light/rocket-launch.svg';
import {ReactComponent as LightRotateLeft} from '../../Icons/Light/rotate-left.svg';
import {ReactComponent as LightRotateRight} from '../../Icons/Light/rotate-right.svg';
import {ReactComponent as LightRoute} from '../../Icons/Light/route.svg';
import {ReactComponent as LightSlider} from '../../Icons/Light/slider.svg';
import {ReactComponent as LightStar} from '../../Icons/Light/star.svg';
import {ReactComponent as LightStars} from '../../Icons/Light/stars.svg';
import {ReactComponent as LightSterlingSign} from '../../Icons/Light/sterling-sign.svg';
import {ReactComponent as LightStop} from '../../Icons/Light/stop.svg';
import {ReactComponent as LightSquare} from '../../Icons/Light/square.svg';
import {ReactComponent as LightSquareCheck} from '../../Icons/Light/square-check.svg';
import {ReactComponent as LightTag} from '../../Icons/Light/tag.svg';
import {ReactComponent as LightTimer} from '../../Icons/Light/timer.svg';
import {ReactComponent as LightThumbsDown} from '../../Icons/Light/thumbs-down.svg';
import {ReactComponent as LightThumbsUp} from '../../Icons/Light/thumbs-up.svg';
import {ReactComponent as LightToolbox} from '../../Icons/Light/toolbox.svg';
import {ReactComponent as LightTrash} from '../../Icons/Light/trash-can.svg';
import {ReactComponent as LightTriangle} from '../../Icons/Light/triangle.svg';
import {ReactComponent as LightTriangleExclamation} from '../../Icons/Light/triangle-exclamation.svg';
import {ReactComponent as LightTruckFast} from '../../Icons/Light/truck-fast.svg';
import {ReactComponent as LightUmbrellaBeach} from '../../Icons/Light/umbrella-beach.svg';
import {ReactComponent as LightUpChevron} from '../../Icons/Light/chevron-up.svg';
import {ReactComponent as LightUpChevrons} from '../../Icons/Light/chevrons-up.svg';
import {ReactComponent as LightUser} from '../../Icons/Light/user.svg';
import {ReactComponent as LightUserCheck} from '../../Icons/Light/user-check.svg';
import {ReactComponent as LightUserHelmetSafety} from '../../Icons/Light/user-helmet-safety.svg';
import {ReactComponent as LightUserMagnifyingGlass} from '../../Icons/Light/user-magnifying-glass.svg';
import {ReactComponent as LightUserSlash} from '../../Icons/Light/user-slash.svg';
import {ReactComponent as LightVial} from '../../Icons/Light/vial.svg';
import {ReactComponent as LightVolumeSlash} from '../../Icons/Light/volume-slash.svg';
import {ReactComponent as LightWandMagicSparkles} from '../../Icons/Light/wand-magic-sparkles.svg';
import {ReactComponent as LightWrench} from '../../Icons/Light/wrench.svg';
import {ReactComponent as LightXMark} from '../../Icons/Light/xmark.svg';

import {ReactComponent as SolidBan} from '../../Icons/Solid/ban.svg';
import {ReactComponent as SolidBarsFilter} from '../../Icons/Solid/bars-filter.svg';
import {ReactComponent as SolidBatteryThreeQuarters} from '../../Icons/Solid/battery-three-quarters.svg';
import {ReactComponent as SolidBell} from '../../Icons/Solid/bell.svg';
import {ReactComponent as SolidCaretDown} from '../../Icons/Solid/caret-down.svg';
import {ReactComponent as SolidCaretUp} from '../../Icons/Solid/caret-up.svg';
import {ReactComponent as SolidCheck} from '../../Icons/Solid/check.svg';
import {ReactComponent as SolidCircle} from '../../Icons/Solid/circle.svg';
import {ReactComponent as SolidCircleCheck} from '../../Icons/Solid/circle-check.svg';
import {ReactComponent as SolidDoubleCheck} from '../../Icons/Solid/check-double.svg';
import {ReactComponent as SolidLeftChevron} from '../../Icons/Solid/chevron-left.svg';
import {ReactComponent as SolidMicrophone} from '../../Icons/Solid/microphone.svg';
import {ReactComponent as SolidQuestion} from '../../Icons/Solid/question.svg';
import {ReactComponent as SolidThumbsDown} from '../../Icons/Solid/thumbs-down.svg';
import {ReactComponent as SolidThumbsUp} from '../../Icons/Solid/thumbs-up.svg';
import {ReactComponent as SolidTriangleExclamation} from '../../Icons/Solid/triangle-exclamation.svg';
import {ReactComponent as SolidUser} from '../../Icons/Solid/user.svg';
import {ReactComponent as SolidWifi} from '../../Icons/Solid/wifi.svg';
import {ReactComponent as SolidXMark} from '../../Icons/Solid/xmark.svg';

import {ReactComponent as BrandAndroid} from '../../Icons/Brands/android.svg';
import {ReactComponent as BrandApple} from '../../Icons/Brands/apple.svg';
import {ReactComponent as BrandAppStore} from '../../Icons/Brands/app-store.svg';
import {ReactComponent as BrandFacebook} from '../../Icons/Brands/facebook.svg';
import {ReactComponent as BrandGoogle} from '../../Icons/Brands/google.svg';
import {ReactComponent as BrandInstagram} from '../../Icons/Brands/instagram.svg';
import {ReactComponent as BrandMastodon} from '../../Icons/Brands/mastodon.svg';
import {ReactComponent as BrandTrustPilot} from '../../Icons/Light/text.svg';
import {ReactComponent as BrandTwitter} from '../../Icons/Brands/twitter.svg';
import {ReactComponent as BrandYouTube} from '../../Icons/Brands/youtube.svg';

import Logo from "../../Images/Icon-white.png";

const icons = {
    light: {
        'CalendarCheck': LightCalendarCheck,
        'Gear': LightGear,
        'HouseChimney': LightHouseChimney,
        'Truck': LightTruck,
        'Users': LightUsers,

        'AlarmClock': LightAlarmClock,
        'ArrowProgress': LightArrowProgress,
        'ArrowRightToBracket': LightArrowRightToBracket,
        'ArrowsUpDown': LightArrowsUpDown,
        'ArrowUpRightFromSquare': LightArrowUpRightFromSquare,
        'Backward': LightBackward,
        'Ban': LightBan,
        'Bars': LightBars,
        'BarsFilter': LightBarsFilter,
        'Bell': LightBell,
        'BellOn': LightBellOn,
        'Book': LightBook,
        'BoxDollar': LightBoxDollar,
        'Building': LightBuilding,
        'BuildingColumns': LightBuildingColumns,
        'BullseyeArrow': LightBullseyeArrow,
        'Bullhorn': LightBullhorn,
        'Calendar': LightCalendar,
        'CalendarClock': LightCalendarClock,
        'CalendarDay': LightCalendarDay,
        'CalendarPen': LightCalendarPen,
        'CalendarPlus': LightCalendarPlus,
        'CalendarWeek': LightCalendarWeek,
        'CalendarX': LightCalendarX,
        'Camera': LightCamera,
        'ChartSimple': LightChartSimple,
        'Check': LightCheck,
        'CheckDouble': LightCheckDouble,
        'Circle': LightCircle,
        'CircleCheck': LightCircleCheck,
        'CircleDot': LightCircleDot,
        'CircleExclamation': LightCircleExclamation,
        'CircleInfo': LightCircleInfo,
        'CircleX': LightCircleX,
        'ClipboardCheck': LightClipboardCheck,
        'Clock': LightClock,
        'ClockRotateLeft': LightClockRotateLeft,
        'CloudArrowDown': LightCloudArrowDown,
        'CloudArrowUp': LightCloudArrowUp,
        'Comment': LightComment,
        'Copy': LightCopy,
        'CreditCardFront': LightCreditCardFront,
        'DownChevron': LightDownChevron,
        'DownChevrons': LightDownChevrons,
        'DrawPolygon': LightDrawPolygon,
        'EnvelopeOpen': LightEnvelopeOpen,
        'Exclamation': LightExclamation,
        'Eye': LightEye,
        'EyeSlash': LightEyeSlash,
        'FileCheck': LightFileCheck,
        'FileCertificate': LightFileCertificate,
        'FileInvoice': LightFileInvoice,
        'FileLines': LightFileLines,
        'FilePlusMinus': LightFilePlusMinus,
        'FolderImage': LightFolderImage,
        'FolderOpen': LightFolderOpen,
        'Forward': LightForward,
        'ForwardStep': LightForwardStep,
        'HandPointer': LightHandPointer,
        'Gift': LightGift,
        'GiftCard': LightGiftCard,
        'GlobePointer': LightGlobePointer,
        'Info': LightInfo,
        'LayerGroup': LightLayerGroup,
        'LeftChevron': LightLeftChevron,
        'Link': LightLink,
        'ListCheck': LightListCheck,
        'ListUl': LightListUl,
        'LocationPin': LightLocationPin,
        'LocationQuestion': LightLocationQuestion,
        'Lock': LightLock,
        'MagnifyingGlass': LightMagnifyingGlass,
        'MagnifyingGlassChart': LightMagnifyingGlassChart,
        'Microphone': LightMicrophone,
        'Minus': LightMinus,
        'MoneyBillTransfer': LightMoneyBillTransfer,
        'MoneyBillWave': LightMoneyBillWave,
        'Note': LightNote,
        'Paperclip': LightPaperclip,
        'PaperPlane': LightPaperPlane,
        'PartyHorn': LightPartyHorn,
        'Pencil': LightPencil,
        'Phone': LightPhone,
        'PiggyBank': LightPiggyBank,
        'Pipe': LightPipe,
        'Play': LightPlay,
        'PlayPause': LightPlayPause,
        'Plus': LightPlus,
        'PlusMinus': LightPlusMinus,
        'Question': LightQuestion,
        'Receipt': LightReceipt,
        'RightChevron': LightRightChevron,
        'RocketLaunch': LightRocketLaunch,
        'RotateLeft': LightRotateLeft,
        'RotateRight': LightRotateRight,
        'Route': LightRoute,
        'Slider': LightSlider,
        'Star': LightStar,
        'Stars': LightStars,
        'SterlingSign': LightSterlingSign,
        'Stop': LightStop,
        'Square': LightSquare,
        'SquareCheck': LightSquareCheck,
        'SquareQuestion': LightSquareQuestion,
        'Tag': LightTag,
        'Timer': LightTimer,
        'ThumbsDown': LightThumbsDown,
        'ThumbsUp': LightThumbsUp,
        'Toolbox': LightToolbox,
        'Trash': LightTrash,
        'Triangle': LightTriangle,
        'TriangleExclamation': LightTriangleExclamation,
        'TruckFast': LightTruckFast,
        'UmbrellaBeach': LightUmbrellaBeach,
        'UpChevron': LightUpChevron,
        'UpChevrons': LightUpChevrons,
        'User': LightUser,
        'UserCheck': LightUserCheck,
        'UserHelmetSafety': LightUserHelmetSafety,
        'UserMagnifyingGlass': LightUserMagnifyingGlass,
        'UserSlash': LightUserSlash,
        'Vial': LightVial,
        'VolumeSlash': LightVolumeSlash,
        'WandMagicSparkles': LightWandMagicSparkles,
        'Wrench': LightWrench,
        'XMark': LightXMark,

        // Aliases
        'LinkExternal': LightArrowUpRightFromSquare,
    },
    solid: {
        'Ban': SolidBan,
        'BarsFilter': SolidBarsFilter,
        'BatteryThreeQuarters': SolidBatteryThreeQuarters,
        'Bell': SolidBell,
        'CaretDown': SolidCaretDown,
        'CaretUp': SolidCaretUp,
        'Check': SolidCheck,
        'Circle': SolidCircle,
        'CircleCheck': SolidCircleCheck,
        'DoubleCheck': SolidDoubleCheck,
        'LeftChevron': SolidLeftChevron,
        'Microphone': SolidMicrophone,
        'Question': SolidQuestion,
        'ThumbsDown': SolidThumbsDown,
        'ThumbsUp': SolidThumbsUp,
        'TriangleExclamation': SolidTriangleExclamation,
        'User': SolidUser,
        'Wifi': SolidWifi,
        'XMark': SolidXMark,
    },
    brands: {
        'Android': BrandAndroid,
        'Apple': BrandApple,
        'AppStore': BrandAppStore,
        'Facebook': BrandFacebook,
        'Google': BrandGoogle,
        'Instagram': BrandInstagram,
        'Mastodon': BrandMastodon,
        'TrustPilot': BrandTrustPilot,
        'Twitter': BrandTwitter,
        'YouTube': BrandYouTube,
    },
}

const sizes = {
    '0.25x': 'h-2 w-2',
    '0.5x': 'h-3 w-3',
    '1x': 'h-4 w-4',
    '2x': 'h-6 w-6',
    '3x': 'h-8 w-8',
    '4x': 'h-10 w-10',
    '5x': 'h-12 w-12',
}

const Icon = ({icon, size, className: propsClassName, theme, badge, onClick}) => {
    const _theme = theme ?? 'light';
    let IconComponent;
    if (icon === 'LOGO') {
        IconComponent = TheLogo;
    } else {
        IconComponent = icons[_theme][icon] ?? LightSquareQuestion;
    }

    const sizeClass = sizes[size ?? '1x'] ?? sizes['1x'];

    const className = classNames(
        'relative inline-block',
        sizeClass,
        propsClassName,
        onClick && 'cursor-pointer',
    );

    const handleClick = (e) => {
        if (!onClick) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        onClick();
    }

    return <span className={className} data-testid="icon" onClick={handleClick}>
        <IconComponent className="w-full h-full" />
        <Badge badge={badge} />
    </span>

}

const TheLogo = () => {
    return <img src={Logo} alt="Logo" className="h-full w-full" />
}

const Badge = ({badge}) => {
    if (!badge) {
        return null;
    }

    return <span className='absolute top-0 right-0 mr-[-50%] mt-[-30%] inline-flex rounded-full bg-red-600 text-white px-2 text-xs'>
        {badge === true ? <>&#9679;</> : badge}
    </span>
}

export default Icon;
